import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/imaging-procedures/otherImagingProcedure";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	otherImagingProcedure: {
		id: "ktx.other_imaging_procedure.title",
		defaultMessage: "Egyéb képalkotó vizsgálat"
	},
	result: {
		id: "ktx.other_imaging_procedure.field.result",
		defaultMessage: "Eredmény"
	},
	procedureName: {
		id: "ktx.other_imaging_procedure.field.procedure_name",
		defaultMessage: "Képalkotó vizsgálat megnevezése"
	},
	comment: {
		id: "ktx.other_imaging_procedure.field.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: {
	[key: string]: FieldData;
} = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: resultMessages }
		}
	},
	procedureName: {
		type: "field",
		path: ["procedureName"],
		label: messages.procedureName,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.procedureName }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "ktx_otherImagingProcedure",
	value: {
		schemaId: "otherImagingProcedure",
		title: messages.otherImagingProcedure,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
